import { render, staticRenderFns } from "./UserRolesAutocomplete.vue?vue&type=template&id=208f07fb&"
import script from "./UserRolesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./UserRolesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports